/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import { PrivateRouterProps } from "../interface/route-interface";
import TermsConditions from "../components/terms-conditions";
import WelcomeComponent from "../components/welcome";
import NameComponent from "../components/personalized/name";
import GreetingComponent from "../components/personalized/greeting";
import PersonalDetailsComponent from "../components/personalized";
import LoginSuccessful from "../components/amway-id";
import { LoginCallback } from "@okta/okta-react";
import ResultsLandingPage from "../components/results-landing";
import SummaryComponent from "../components/summary";
import HomeComponent from "../components/home";
import PageNotFound from "../components/shared-ui/errors/page-not-found";
import PickSurveyComponent from "../components/achievers";
import AdminLogin from "../components/admin";
import TestCaseDashboard from "../components/admin/test-dashboard";
import ViewTestCase from "../components/admin/view-testCases";

/**
 * This funcation is used to store all route props.
 *
 * @namespace Route
 */
const routes: PrivateRouterProps[] = [
  {
    path: "/",
    exact: true,
    component: WelcomeComponent,
    showHeader: false,
  },
  {
    path: "/loginsuccessful",
    exact: true,
    component: LoginSuccessful,
  },
  {
    path: ["/login/callback", "/admin/login/callback"],
    component: LoginCallback,
    // component: AmwayIDLoginCallback,
  },
  {
    path: "/terms",
    exact: true,
    component: TermsConditions,
    showHeader: false,
  },
  {
    path: "/admin",
    exact: true,
    component: AdminLogin,
    showHeader: false,
  },
  {
    path: "/hello",
    exact: true,
    component: NameComponent,
    showHeader: true,
  },
  {
    path: "/greeting",
    exact: true,
    component: GreetingComponent,
    showHeader: true,
  },
  {
    path: "/foundational",
    exact: true,
    component: PersonalDetailsComponent,
    showHeader: true,
  },
  {
    path: "/results",
    exact: true,
    component: ResultsLandingPage,
    showHeader: false,
  },
  {
    path: "/summary",
    exact: true,
    component: SummaryComponent,
    showHeader: false,
  },
  {
    path: "/home",
    exact: true,
    component: HomeComponent,
    showHeader: false,
  },
  {
    path: "/achievers",
    exact: true,
    component: PickSurveyComponent,
    showHeader: false,
  },
  {
    path: "/admin/testlist",
    exact: true,
    component: ViewTestCase,
    showHeader: true,
  },
  {
    path: "/admin/dashboard",
    exact: true,
    component: TestCaseDashboard,
    showHeader: true,
  },
  {
    path: "*",
    component: PageNotFound,
    showHeader: false,
  },
];
export default routes;
